import Api from "js/core/api";

async function addCollaboratorsToLibraryItemInPresentation(libraryItemId, presentationId) {
    return Api.libraryItems.put({ type: "add_collab_permission", libraryItemId, presentationId });
}

async function removeCollaboratorsToLibraryItemInPresentation(libraryItemId, presentationId) {
    return Api.libraryItems.put({ type: "remove_collab_permission", libraryItemId, presentationId });
}

export default {
    addCollaboratorsToLibraryItemInPresentation,
    removeCollaboratorsToLibraryItemInPresentation
};

